import { FETCH_RESERVATIONS_REQUEST, FETCH_RESERVATIONS_SUCCESS, FETCH_RESERVATIONS_ERROR } from '../constants/ActionTypes'

export default function fetchReservationsError(state = false, action) {
    switch (action.type) {
        case FETCH_RESERVATIONS_REQUEST:
        case FETCH_RESERVATIONS_SUCCESS:
            return false
        case FETCH_RESERVATIONS_ERROR:
            return true
        default:
            return state
    }
}
